<template>
  <HeroBackgroundFull>
    <template v-slot:image>
      <img src="@/assets/UltrackHero.jpg" />
    </template>
    <template v-slot:title>
      <div class="text-white">Any time.</div>
      <div class="text-white">Anywhere.</div>
      <div class="text-accent-light filter brightness-125">Securely.</div>
    </template>
  </HeroBackgroundFull>

  <!-- Track & Manage Your Fleet, Anytime, Anywhere -->
  <Split
    title="Track & Manage Your Fleet, Anytime, Anywhere"
    description="Viewing your assets from your mobile/smart phone device, tablet or desktop - conveniently allowing you to stay in touch with your fleet at all times"
  >
    <img src="@/assets/UltrackMap.jpg" />
  </Split>

  <!-- Three Decades -->
  <Banner
    title="We have taken over three decades of GPS tracking from a simple
  BLIP on the screen to the next generation of vehicle data and fleet tracking."
    description="Turn data and insight into business results with powerful
  features and the support of an experienced team"
  />

  <FeatureSideImage
    class="bg-accent-lightest"
    label="Features"
    title="Ultrack Offers More"
    description="A user friendly management system that offers informative real-time data to improve your business"
    :features="features"
  >
    <template v-slot:image>
      <img src="@/assets/UltrackDriver.jpg" />
    </template>
  </FeatureSideImage>
</template>

<script>
import FeatureSideImage from "../../components/FeatureSideImage.vue";
import HeroBackgroundFull from "../../components/layouts/hero/HeroBackgroundFull.vue";
import FeatureGrid from "@/components/layouts/FeatureGrid.vue";
import Banner from "@/components/layouts/Banner.vue";
import Split from "@/components/layouts/Split.vue";
import HeroCardBackgroundImage from "@/components/layouts/hero/HeroCardBackgroundImage.vue";
import Container from "@/components/base/Container";
import Header from "@/components/base/Header";
import {
  AnnotationIcon,
  AdjustmentsIcon,
  CashIcon,
  ShieldCheckIcon,
  // ScaleIcon,
} from "@heroicons/vue/outline";

const features = [
  {
    name: "Control",
    description:
      "Asset visibility through tracking in real time. Information such as location, speed , means that you can manage your resources more efficiently",
    icon: AdjustmentsIcon,
  },
  {
    name: "Safety & Security",
    description:
      "Recovering stolen assets, protecting high valued goods and limiting liabilities",
    icon: ShieldCheckIcon,
  },
  {
    name: "Savings",
    description:
      "No more unauthorized stops, alternate routes. Verify hours worked on employee time cards. Savings on time and fuel all add to your bottom line",
    icon: CashIcon,
  },
  {
    name: "Service",
    description:
      "We recognize the needs of our customers, offering device augmentation and custom reporting to suit your needs",
    icon: AnnotationIcon,
  },
];
export default {
  components: {
    Container,
    Header,
    HeroCardBackgroundImage,
    Split,
    Banner,
    FeatureGrid,
    HeroBackgroundFull,
    FeatureSideImage,
  },
  setup() {
    return { features };
  },
};
</script>
